import { WearablesEntity } from "./wearables.entities";
import { calculateParticipantRowMetrics, calculateRowMetrics, dialogMetricColumnDefs, EmptyMetric, metricColumnDefs } from "./wearables.functions";

export class WearablesPlatformTab {

    wearablesData: WearablesEntity[];

    tableSelector: string;
    table: any;
    dialogTable: any;

    constructor(tableSelector: string, wearablesData: WearablesEntity[]) {
        this.tableSelector = tableSelector;
        this.wearablesData = wearablesData;
    }

    initializeTable() {
        this.table = $(this.tableSelector).DataTable({
            "dom": 'lrtip',
            autoWidth: true,
            info: false,
            paging: false,
            search: false,
            scrollX: true,
            scrollY: '70vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 3
            },
            columns: [
                { data:'platform', title: 'Platform', className: 'text-left font-size12 nowrap' },
                { data:'trial', title: 'Trial', className: 'text-left font-size12 nowrap trial-col' },
                { data:'totalParticipants', title: 'Total<br>Participants', className: 'text-center font-size12 nowrap last-fixed' },
                ...metricColumnDefs,
            ]
        });

        $(this.tableSelector).on('click', 'tr', this, function (evt) {
            const row = $(evt.data.tableSelector).DataTable().row(this).data();
            evt.data.showDialog(row.sites, row.trialId, row.trial);
        });

        this.initializeDialog();
    }

    updateData(filter) {
        if (!filter) return;

        const rows = [];
        filter.selectedAppendixIds.forEach((aid) => {
            const appendix = filter.appendices.find((a) => a.Id === aid);
            const study = filter.studies.find((s) => s.Id === appendix.StudyId);
            const group = this.wearablesData.filter((w) => ((w.AppendixId === appendix.Id) && (filter.selectedSiteIds.includes(w.SiteNumber))));

            const metrics = calculateRowMetrics(group);

            rows.push({
                platform: study.Name,
                trial: appendix.Name,
                trialId: aid,
                sites: filter.selectedSiteIds,
                totalParticipants: metrics.totalParticipants,
                syncedBase: metrics.syncedBase,
                avgSyncedBase: metrics.avgSyncedBase,
                zeroSyncedBase: metrics.zeroSyncedBase,
                syncedMoi: (appendix.StudyId === 6) ? metrics.syncedMoi : EmptyMetric,
                avgSyncedMoi: metrics.avgSyncedMoi,
                zeroSyncedMoi: (appendix.StudyId === 6) ? metrics.zeroSyncedMoi : EmptyMetric,
                syncedEoi: metrics.syncedEoi,
                avgSyncedEoi: metrics.avgSyncedEoi,
                zeroSyncedEoi: metrics.zeroSyncedEoi,
                syncedEos: ((appendix.StudyId === 6) || (appendix.StudyId === 4)) ? metrics.syncedEos : EmptyMetric,
                avgSyncedEos: metrics.avgSyncedEos,
                zeroSyncedEos: ((appendix.StudyId === 6) || (appendix.StudyId === 4)) ? metrics.zeroSyncedEos : EmptyMetric,
                num3day: metrics.num3day,
                num7day: metrics.num7day,
                num10day: metrics.num10day,
                notifyCoord: metrics.notifyCoord,
            });
        });

        this.table.clear();
        this.table.rows.add(rows).draw();
    }

    refresh() {
        this.table.draw();
    }

    initializeDialog() {
        this.dialogTable = $('#dialog-platform-details-table').DataTable({
            "dom": 'lrtip',
            autoWidth: true,
            info: false,
            paging: false,
            search: false,
            scrollX: true,
            scrollY: '70vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 2
            },
            columns: [
                // { data:'platform', title: 'Platform', className: 'text-left font-size12 nowrap' },
                // { data:'trial', title: 'Trial', className: 'text-left font-size12 nowrap' },
                { data:'participantId', title: 'Participant', className: 'text-center font-size12 nowrap' },
                ...dialogMetricColumnDefs
            ]
        });

        $('#platform-details-modal').on('shown.bs.modal', () => {
            this.dialogTable.draw();
        });
    }

    showDialog(sites: number[], trialId: number, trialName: string) {

        const participants = this.wearablesData
            .filter((w) => (sites.includes(w.SiteNumber) && (w.AppendixId === trialId)))
            .map((p) => calculateParticipantRowMetrics(p));

        this.dialogTable.clear();
        this.dialogTable.rows.add(participants).draw();

        $('#platform-details-modal-title').text(`${trialName}`);
        $('#platform-details-modal').modal('show');
    }
}